import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Search } from "lucide-react";
import { BANNERS, TIPOLOGIE, COMUNI, AGENZIE } from "@/lib/data";
import { SearchForm } from "@/components/site/SearchForm";

const Slider = () => {
  const [i, setI] = useState(0);
  const n = BANNERS.length;
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % n), 5000);
    return () => clearInterval(t);
  }, [i, n]);
  return (
    <section data-testid="home-slider" className="relative w-full aspect-[3/2] max-h-[860px] overflow-hidden bg-gray-200">
      {BANNERS.map((src, k) => (
        <img key={src} src={src} alt="IVCasa Gruppo Immobiliare" data-testid={`home-slide-${k}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${k === i ? "opacity-100" : "opacity-0"}`} />
      ))}
      <button aria-label="Precedente" onClick={() => setI((x) => (x - 1 + n) % n)} data-testid="slider-prev"
        className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 grid place-items-center bg-black/30 text-white hover:bg-black/50"><ChevronLeft /></button>
      <button aria-label="Successiva" onClick={() => setI((x) => (x + 1) % n)} data-testid="slider-next"
        className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 grid place-items-center bg-black/30 text-white hover:bg-black/50"><ChevronRight /></button>
    </section>
  );
};

const Cerca = () => (
  <section id="cerca" data-testid="home-search" className="relative overflow-hidden">
    <img src="/img/ivcasa-coppia-chiavi-di-casa-con-scritte.jpg" alt="" className="absolute inset-0 w-full h-full object-cover blur-[6px] scale-110" />
    <div className="absolute inset-0 bg-black/45" />
    <div className="relative max-w-[1240px] mx-auto px-4 py-8">
      <h2 className="font-tit font-bold text-white uppercase text-2xl sm:text-[36px] text-center flex items-center justify-center gap-3 mb-6">
        <Search className="w-6 h-6 sm:w-8 sm:h-8 shrink-0" strokeWidth={3} /> Cerca il tuo immobile
      </h2>
      <SearchForm light />
    </div>
  </section>
);

const Tipologie = () => (
  <section data-testid="home-tipologie" className="max-w-[1240px] mx-auto px-4 pt-10 space-y-9 border-t border-gray-300 mt-0.5">
    <h2 className="sr-only">Ricerca tipologica</h2>
    {TIPOLOGIE.map((t) => (
      <Link key={t.slug} to={`/${t.slug}`} data-testid={`tipologia-${t.slug}-link`} className="group relative block h-[150px] sm:h-auto sm:aspect-[1210/280] overflow-hidden">
        <img src={t.img} alt={t.nome} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/40 group-hover:bg-white/10 transition-colors duration-300" />
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border border-[#333] bg-white/70 px-4 py-1 font-tit font-bold uppercase text-xl sm:text-2xl text-[#111]">
          {t.nome}
        </span>
      </Link>
    ))}
  </section>
);

const ComuniAgenzie = () => (
  <section data-testid="home-comuni-agenzie" className="max-w-[1240px] mx-auto px-4 pt-14 grid grid-cols-1 lg:grid-cols-3 gap-10">
    <div className="lg:col-span-2">
      <h2 className="font-tit font-bold text-[var(--iv)] uppercase text-2xl mb-4">Ricerca rapida comuni</h2>
      <ul className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-1.5 text-[15px]">
        {COMUNI.map((c) => (
          <li key={c}><Link to={`/immobili?comune=${encodeURIComponent(c)}`} className="hover:text-[var(--iv)]" data-testid={`comune-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}>» {c}</Link></li>
        ))}
      </ul>
    </div>
    <div>
      <h2 className="font-tit font-bold text-[var(--iv)] uppercase text-2xl mb-4">Le nostre agenzie</h2>
      <ul className="space-y-3 text-[15px]">
        {AGENZIE.map((a) => (
          <li key={a.id} data-testid={`home-agenzia-${a.id}`}>
            <p className="font-bold uppercase">{a.nome}</p>
            <p>{a.indirizzo} - {a.citta} (FI)</p>
          </li>
        ))}
      </ul>
      <Link to="/dove-siamo" className="inline-block mt-4 text-[var(--iv)] font-bold hover:underline" data-testid="home-dove-siamo-link">Tutte le sedi »</Link>
    </div>
  </section>
);

export default function Home() {
  return (
    <div data-testid="home-page">
      <Slider />
      <Cerca />
      <Tipologie />
      <ComuniAgenzie />
    </div>
  );
}
